module.exports = __webpack_public_path__ + "img/welcome.46f5d48c.png";